import React, { ReactElement } from 'react';
import { Button } from 'react-bootstrap';
import { render } from 'react-dom';
import styled from 'styled-components';

import { BaseDialog } from './baseDialog';
import { Modal } from './modal';

export class Alert extends BaseDialog<boolean> {
  private persistent: boolean = null;

  constructor(message: ReactElement | string, buttonText = 'OK', persistent = false) {
    super();
    this.el = document.createElement('div');
    this.el.id = 'confirm';
    this.persistent = persistent;

    document.body.appendChild(this.el);

    render(
      <Modal isOpen onToggle={this.close} dialog contentLabel='Alert'>
        <Padded data-test="alert">
          <p>{message}</p>

          <Button onClick={this.confirm}>{buttonText}</Button>
        </Padded>
      </Modal>,
      this.el,
    );
  }

  alert = () => false;

  close = (evt?: any) => {
    if (this.persistent) {
      return false;
    }

    evt?.preventDefault();
    evt?.stopPropagation();

    this.resolvePromise(false);
    this.unmount();
  };
}

const Padded = styled.div`
  padding: 2em;
  padding-bottom: 1em;
  text-align: center;
  min-width: 20em;
`;
